import Text from '../../core/Text';
import View from '../../core/View';

type Props = { notices: string[] };

// 원본 문항 수정 창의 "함께 처리되는 것" 안내
const TaskOriginalUpdateNoticeList = ({ notices }: Props) => (
  <View sx={{ marginTop: 3 }}>
    <Text fontSize={1} fontWeight={'bold'}>
      함께 처리되는 것
    </Text>
    <View as={'ul'} sx={{ marginTop: 1, marginBottom: 0, paddingLeft: 4 }}>
      {notices.map((notice) => (
        <View as={'li'} key={notice}>
          <Text fontSize={1} color={'fg.muted'}>
            {notice}
          </Text>
        </View>
      ))}
    </View>
  </View>
);

export default TaskOriginalUpdateNoticeList;
